<style scoped>
.order-book {
  overflow: auto;
}

.red {
  color: var(--color-danger-light);
}

.red:hover {
  text-decoration: underline;
}

.green:hover {
  text-decoration: underline;
}

.green {
  color: var(--color-success-light);
}

.bgred {
  position: absolute;
  left: -2px;
  top: 0;
  bottom: 1px;
  background-color: var(--color-danger-light);
  opacity: 0.2;
  /*z-index: -1;*/
}

.bggreen {
  position: absolute;
  left: -2px;
  top: 0;
  bottom: 1px;
  background-color: darkseagreen;
  opacity: 0.2;
  /*z-index: -1;*/
}
</style>

<template>
  <div>
    <div
      class="box symbbox order-book"
      style="font-size: 14px; text-align: left; font-weight: normal;"
    >
      <Row style="font-weight: bold; font-size: 12px">
        <i-col span="9">{{ $text.tr('ЦЕНА')}}</i-col>
        <i-col span="9">{{ $text.tr('КОЛ-ВО')}}</i-col>
        <i-col span="6">{{ $text.tr('СУММА')}}</i-col>
      </Row>
      <!--<Row>-->
      <!--<i-col span="24">-->
      <div style="height: 10px;"></div>
      <!--</i-col>-->
      <!--</Row>-->

      <Row
        v-for="(ask, index) in orderbook.Ask"
        :key="`ask-${index}`"
      >
        <i-col
          span="9"
          class="red"
          style="font-weight: bold;"
        >
          <div
            v-on:click="selectPrice(ask.Price)"
            style="cursor: pointer;"
          >
            {{ ask.Price }}
            <div
              class="bgred"
              v-bind:style="{ width : ask.Qty * priceusd * 0.01 < 96 ? ask.Qty * priceusd * 0.01 + '%' : '96%' }"
            ></div>
          </div>
        </i-col>
        <i-col span="9">{{ ask.Qty }}</i-col>
        <i-col span="6">{{ (ask.Price*ask.Qty).toFixed(decPlaces) }}</i-col>
      </Row>
      <Row
        v-for="(bid, index) in orderbook.Bid"
        :key="`bid-${index}`"
      >
        <i-col
          span="9"
          class="green"
          style="font-weight: bold;"
        >
          <div
            v-on:click="selectPrice(bid.Price)"
            style="cursor: pointer;"
          >
            {{ bid.Price }}
            <div
              class="bggreen"
              v-bind:style="{ width : bid.Qty * priceusd * 0.01 < 96 ? bid.Qty * priceusd * 0.01 + '%' : '96%' }"
            ></div>
          </div>
        </i-col>
        <i-col span="9">{{ bid.Qty }}</i-col>
        <i-col span="6">{{ (bid.Price*bid.Qty).toFixed(decPlaces) }}</i-col>
      </Row>
    </div>
  </div>
</template>

<script>
import Decimal from 'decimal.js'
import ReconnectingWebSocket from 'reconnecting-websocket'
import Api from '@/util/api'

const ftxUrl = 'wss://ftx.com/ws/'
const okxUrl = 'wss://ws.okx.com:8443/ws/v5/public'
const bybitFuturesUrl = 'wss://stream.bybit.com/v5/public/linear'
const bybitSpotUrl = 'wss://stream.bybit.com/v5/public/spot'
const binanceSpotUrl = 'wss://stream.binance.com:9443/ws/'
const binanceFuturesUrl = 'wss://fstream.binance.com/ws/'
const bitgetUrl = 'wss://ws.bitget.com/v2/ws/public'

let ws = null

let pingInterval = null
let showInterval = null

let obook = null
const OBOOK_INT_SIZE = 20
const OBOOK_DISPLAY_DEPTH = 8
const UPDATE_TIMEOUT = 1000

export default {
  name: 'OrderBook',
  data: function () {
    return {
      orderbook: {
        Ask: [],
        Bid: []
      },
      okxOrderbook: {
        Ask: [],
        Bid: []
      },
      okxStream: {},
      bybitStream: {},
      binStream: {},
      bitgetStream: {},
      priceusd: 0,
      decPlaces: 2,
      orderbookInterval: null,
      orderbookFtxInterval: null
    }
  },

  watch: {
    '$store.state.sys.chartInfo': function (chartInfo) {
      // console.log('orderBook: ', JSON.stringify(chartInfo))
      this.closeOkxStream()
      this.closeBybitStream()
      this.closeBinStream()
      this.closeBitgetStream()

      const ExchId = this.$store.state.sys.tradeExchange.ExchId
      if (ExchId === 'FTX') {
        this.updateFtxWsSnapshot()
      } else if (ExchId === 'OKX') {
        this.startOKXStream()
      } else if (ExchId === 'BYB' || ExchId === 'BYF') {
        this.startBybitStream()
      } else if (ExchId === 'BIN' || ExchId === 'BIF') {
        this.startBINStream()
      } else if (ExchId === 'GET' || ExchId === 'GEF') {
        this.startBitgetStream()
      } else {
        this.updateOrderBook()
      }
    }
  },

  methods: {
    closeOkxStream () {
      this.okxStream.close && this.okxStream.close()
    },
    closeBybitStream () {
      this.bybitStream.close && this.bybitStream.close()
    },
    closeBinStream () {
      this.binStream.close && this.binStream.close()
    },
    closeBitgetStream () {
      this.bitgetStream.close && this.bitgetStream.close()
    },
    startBybitStream () {
      const ExchId = this.$store.state.sys.tradeExchange.ExchId
      let wsUrl
      if (ExchId === 'BYB') {
        wsUrl = bybitSpotUrl
      } else if (ExchId === 'BYF') {
        wsUrl = bybitFuturesUrl
      } else {
        return
      }
      const bybitOrderbook = { Ask: {}, Bid: {} }
      let lastUpdateTime = 0
      const symbol = this.$store.state.trade.symbol.replace('_', '')
      this.bybitStream = new ReconnectingWebSocket(wsUrl)

      const toObject = data => Object.fromEntries(data.slice(0, OBOOK_INT_SIZE))

      const getUpdatedLevels = (data, currentLevels) => {
        if (!data || !data.length) {
          return currentLevels
        }
        const book = { ...currentLevels, ...Object.fromEntries(data) }
        for (const price in book) {
          if (book[price] === '0') delete book[price]
        }
        return book
      }

      const toArray = (book) => Object.entries(book)
        .sort((a, b) => b[0] - a[0])
        .map(([price, qty]) => ({ Price: parseFloat(price), Qty: parseFloat(qty) }))

      const render = () => {
        const now = +new Date()
        if (lastUpdateTime + UPDATE_TIMEOUT < now) {
          lastUpdateTime = now
          this.priceusd = this.$store.state.sys.lastPrice
          this.orderbook = {
            Ask: toArray(bybitOrderbook.Ask).slice(-OBOOK_DISPLAY_DEPTH),
            Bid: toArray(bybitOrderbook.Bid).slice(0, OBOOK_DISPLAY_DEPTH)
          }
        }
      }

      this.bybitStream.onopen = e => {
        this.bybitStream.send(JSON.stringify({
          op: 'subscribe',
          // 50 is the smallest full orderbook depth for linear/spot: https://bybit-exchange.github.io/docs/v5/websocket/public/orderbook
          args: ['orderbook.50.' + symbol]
        }))
      }

      this.bybitStream.onmessage = e => {
        const message = JSON.parse(e.data)
        if (message.topic && message.data) {
          if (message.type === 'snapshot') {
            bybitOrderbook.Ask = toObject(message.data.a)
            bybitOrderbook.Bid = toObject(message.data.b)
          } else if (message.type === 'delta') {
            bybitOrderbook.Ask = getUpdatedLevels(message.data.a, bybitOrderbook.Ask)
            bybitOrderbook.Bid = getUpdatedLevels(message.data.b, bybitOrderbook.Bid)
          }
          render()
        }
      }

      this.bybitStream.onerror = err => {
        err.message && console.log('err bybit ws: ' + err.message)
      }

      this.bybitStream.onclose = e => {
        console.log('bybit ws closed: ' + symbol)
      }
    },
    startBINStream () {
      const ExchId = this.$store.state.sys.tradeExchange.ExchId
      let wsUrl
      if (ExchId === 'BIN') {
        wsUrl = binanceSpotUrl
      } else if (ExchId === 'BIF') {
        wsUrl = binanceFuturesUrl
      } else {
        return
      }

      let lastUpdateTime = 0
      const symbol = this.$store.state.trade.symbol.replace('_', '').toLowerCase()
      // depth10 = top 10 levels, 100ms update: https://developers.binance.com/docs/binance-spot-api-docs/web-socket-streams#partial-book-depth-streams
      this.binStream = new ReconnectingWebSocket(wsUrl + symbol + '@depth10@100ms')

      const binOrderbook = {
        Ask: [],
        Bid: []
      }

      const mapData = data => {
        return data.slice(0, OBOOK_INT_SIZE).map(x => {
          return {
            Price: parseFloat(x[0]),
            Qty: parseFloat(x[1])
          }
        })
      }

      const render = () => {
        const now = +new Date()
        if (lastUpdateTime + UPDATE_TIMEOUT < now) {
          lastUpdateTime = now
          this.priceusd = this.$store.state.sys.lastPrice
          this.orderbook = {
            Ask: binOrderbook.Ask.slice(Math.max(binOrderbook.Ask.length - OBOOK_DISPLAY_DEPTH, 0)),
            Bid: binOrderbook.Bid.slice(0, OBOOK_DISPLAY_DEPTH)
          }
        }
      }

      this.binStream.onmessage = e => {
        const data = JSON.parse(e.data)
        // Spot uses 'asks'/'bids', Futures uses 'a'/'b'
        const asks = data.asks || data.a
        const bids = data.bids || data.b
        if (asks && bids) {
          binOrderbook.Ask = mapData(asks).reverse()
          binOrderbook.Bid = mapData(bids)
          render()
        }
      }

      this.binStream.onerror = err => {
        err.message && console.log('err binance ws: ' + err.message)
      }

      this.binStream.onclose = e => {
        console.log('binance ws closed: ' + symbol)
      }
    },
    startBitgetStream () {
      const ExchId = this.$store.state.sys.tradeExchange.ExchId
      let instType
      if (ExchId === 'GET') {
        instType = 'SPOT'
      } else if (ExchId === 'GEF') {
        instType = 'USDT-FUTURES'
      } else {
        return
      }

      let lastUpdateTime = 0
      const symbol = this.$store.state.trade.symbol.replace('_', '')
      this.bitgetStream = new ReconnectingWebSocket(bitgetUrl)

      const bitgetOrderbook = {
        Ask: [],
        Bid: []
      }

      const mapData = data => {
        return data.slice(0, OBOOK_INT_SIZE).map(x => {
          return {
            Price: parseFloat(x[0]),
            Qty: parseFloat(x[1])
          }
        })
      }

      const render = () => {
        const now = +new Date()
        if (lastUpdateTime + UPDATE_TIMEOUT < now) {
          lastUpdateTime = now
          this.priceusd = this.$store.state.sys.lastPrice
          this.orderbook = {
            Ask: bitgetOrderbook.Ask.slice(Math.max(bitgetOrderbook.Ask.length - OBOOK_DISPLAY_DEPTH, 0)),
            Bid: bitgetOrderbook.Bid.slice(0, OBOOK_DISPLAY_DEPTH)
          }
        }
      }

      this.bitgetStream.onopen = e => {
        this.bitgetStream.send(JSON.stringify({
          op: 'subscribe',
          args: [{
            instType,
            // books15 pushes full 15-level snapshots: https://www.bitget.com/api-doc/spot/websocket/public/Depth-Channel
            channel: 'books15',
            instId: symbol
          }]
        }))
      }

      this.bitgetStream.onmessage = e => {
        if (e.data === 'pong') return
        const message = JSON.parse(e.data)
        const data = message.data && message.data[0]
        if (!data || !data.asks || !data.bids) return
        bitgetOrderbook.Ask = mapData(data.asks).reverse()
        bitgetOrderbook.Bid = mapData(data.bids)
        render()
      }

      this.bitgetStream.onerror = err => {
        err.message && console.log('err bitget ws: ' + err.message)
      }

      this.bitgetStream.onclose = e => {
        console.log('bitget ws closed: ' + symbol)
      }
    },
    startOKXStream () {
      if (this.$store.state.sys.tradeExchange.ExchId !== 'OKX') {
        return
      }

      let lastUpdateTime = 0
      const symbol = this.$store.state.trade.symbol.replace('_', '-').replace('-PERP-USDT', '-USDT-SWAP')
      this.okxStream = new ReconnectingWebSocket(okxUrl)
      const params = {
        op: 'subscribe',
        args: [
          {
            // https://www.okx.com/docs-v5/en/#order-book-trading-market-data-ws-order-book-channel
            channel: 'books',
            instId: symbol
          }
        ]
      }

      const mapData = data => {
        return data.slice(0, OBOOK_INT_SIZE).map(x => {
          return {
            Price: x[0],
            Qty: x[1]
          }
        })
      }

      const getUpdatedLevels = (data, key) => {
        const parsedOrderBook = this.okxOrderbook[key].map(obj =>
          Object.values(obj)
        )
        const array = [...parsedOrderBook, ...data]
        const map = new Map(array)
        const result = Array.from(map)
          .filter(arr => +arr[1] !== 0)
          .sort((a, b) => b[0] - a[0])

        return mapData(result)
      }

      const render = () => {
        const now = +new Date()
        if (lastUpdateTime + UPDATE_TIMEOUT < now) {
          lastUpdateTime = now
          this.priceusd = this.$store.state.sys.lastPrice
          this.orderbook = { ...this.okxOrderbook }
        }
      }

      const applySnapshot = (data) => {
        this.okxOrderbook.Ask = mapData(data.asks.slice(-OBOOK_DISPLAY_DEPTH)).reverse()
        this.okxOrderbook.Bid = mapData(data.bids.slice(0, OBOOK_DISPLAY_DEPTH))
      }

      const updateSnapshot = (data) => {
        if (data.asks) {
          const asks = getUpdatedLevels(data.asks, 'Ask')
          this.okxOrderbook.Ask = asks.slice(-OBOOK_DISPLAY_DEPTH)
        }

        if (data.bids) {
          const bids = getUpdatedLevels(data.bids, 'Bid')
          this.okxOrderbook.Bid = bids.slice(0, OBOOK_DISPLAY_DEPTH)
        }
      }

      this.okxStream.onmessage = e => {
        const message = JSON.parse(e.data)
        const data = message.data && message.data.length ? message.data[0] : []

        if (message.action === 'snapshot') {
          applySnapshot(data)
        } else if (message.action === 'update') {
          updateSnapshot(data)
        }

        render()
      }

      this.okxStream.onopen = e => {
        this.okxStream.send(JSON.stringify(params))
      }

      this.okxStream.onerror = err => {
        err.message && console.log('err okx ws: ' + err.message)
      }

      this.okxStream.onclose = e => {
        console.log('okx ws closed: ' + symbol)
      }
    },
    updateFtxWsSnapshot () {
      if (this.$store.state.sys.tradeExchange.ExchId !== 'FTX') {
        return
      }
      // if (ws && ws.readyState === 1) {
      //   console.log('state: ' + ws.readyState)
      //   ws.close()
      // }
      let symbol = this.$store.state.trade.symbol.replace('_', '/')
      if (symbol.includes('-')) {
        symbol = symbol.replace('/USD', '')
      }
      // console.log('ws update: ' + symbol)
      const ws = new ReconnectingWebSocket(ftxUrl)
      ws.send(
        JSON.stringify({
          op: 'subscribe',
          channel: 'orderbook',
          market: symbol
        })
      )

      ws.onopen = e => {
        // console.log('ws connected: ' + symbol)
      }

      ws.onclose = e => {
        // console.log('ws closed: ' + symbol)
      }

      ws.onmessage = e => {
        // console.log('ftx orderbook data:', e.data)
        const bookUpdate = JSON.parse(e.data)
        if (bookUpdate.type === 'partial') {
          // console.log('partial obook update', bookUpdate)
          obook = {
            Ask: bookUpdate.data.asks
              .slice(0, OBOOK_INT_SIZE)
              .reverse()
              .map(x => {
                return {
                  Price: x[0],
                  Qty: x[1]
                }
              }),
            Bid: bookUpdate.data.bids.slice(0, OBOOK_INT_SIZE).map(x => {
              return {
                Price: x[0],
                Qty: x[1]
              }
            })
          }
          // console.log('obook', obook)
          this.orderbook = {
            Ask: obook.Ask.slice(Math.max(obook.Ask.length - OBOOK_DISPLAY_DEPTH, 0)),
            Bid: obook.Bid.slice(0, OBOOK_DISPLAY_DEPTH)
          }
          ws.close()
        } else if (bookUpdate.type === 'update') {
          ws.close()
        }
      }
    },
    clearFtxWs () {
      if (ws) {
        // return
        clearInterval(pingInterval)
        clearInterval(showInterval)
        ws.close()
        ws = null
      }
    },
    updateFtxWs () {
      if (ws) {
        // return
        clearInterval(pingInterval)
        clearInterval(showInterval)
        ws.close()
      }
      let symbol = this.$store.state.trade.symbol.replace('_', '/')
      if (symbol.includes('-')) {
        symbol = symbol.replace('/USD', '')
      }
      ws = new ReconnectingWebSocket(ftxUrl)
      ws.send(
        JSON.stringify({
          op: 'subscribe',
          channel: 'orderbook',
          market: symbol
        })
      )

      pingInterval = setInterval(() => {
        if (ws) {
          ws.send('{"op": "ping"}')
        }
      }, 15000)

      showInterval = setInterval(() => {
        this.orderbook.Ask = JSON.parse(
          JSON.stringify(obook.Ask.slice(Math.max(obook.Ask.length - OBOOK_DISPLAY_DEPTH, 0)))
        )
        this.orderbook.Bid = JSON.parse(JSON.stringify(obook.Bid.slice(0, OBOOK_DISPLAY_DEPTH)))
        this.priceusd = this.$store.state.sys.lastPrice
      }, 2000)

      ws.onclose = e => {
        console.log('ws closed')
      }

      ws.onmessage = e => {
        // console.log('ftx orderbook data:', e.data)
        const bookUpdate = JSON.parse(e.data)
        if (bookUpdate.type === 'partial') {
          console.log('partial obook update', bookUpdate)
          obook = {
            Ask: bookUpdate.data.asks
              .slice(0, OBOOK_INT_SIZE)
              .reverse()
              .map(x => {
                return {
                  Price: x[0],
                  Qty: x[1]
                }
              }),
            Bid: bookUpdate.data.bids.slice(0, OBOOK_INT_SIZE).map(x => {
              return {
                Price: x[0],
                Qty: x[1]
              }
            })
          }
          console.log('obook', obook)
          this.orderbook = {
            Ask: obook.Ask.slice(Math.max(obook.Ask.length - OBOOK_DISPLAY_DEPTH, 0)),
            Bid: obook.Bid.slice(0, OBOOK_DISPLAY_DEPTH)
          }
        } else if (bookUpdate.type === 'update') {
          // console.log('obook update', JSON.stringify(bookUpdate))
          bookUpdate.data.asks.forEach(ask => {
            if (ask[0] < obook.Ask[obook.Ask.length - 1].Price * 1.01) {
              // console.log('obook ask actual update', ask[0], ask[1])
              const i = obook.Ask.findIndex(a => a.Price === ask[0])
              if (i > -1) {
                if (ask[1] === 0) {
                  obook.Ask.splice(i, 1)
                } else {
                  obook.Ask[i].Qty = ask[1]
                }
              } else {
                obook.Ask.push({
                  Price: ask[0],
                  Qty: ask[1]
                })
                // console.log('obook ask added', ask[0], ask[1])
              }
              obook.Ask.sort((a, b) => {
                if (a.Price < b.Price) {
                  return 1
                } else {
                  return -1
                }
              })
              // console.log('obook ask sorted', obook.Ask)
              obook.Ask = obook.Ask.slice(
                Math.max(obook.Ask.length - OBOOK_INT_SIZE, 0)
              )
              // this.orderbook.Ask = obook.Ask.slice(Math.max(obook.Ask.length - OBOOK_DISPLAY_DEPTH, 0))
            }
          })
          bookUpdate.data.bids.forEach(bid => {
            if (bid[0] > obook.Bid[0].Price * 0.99) {
              // console.log('obook bid actual update', bid[0], bid[1])
              const i = obook.Bid.findIndex(a => a.Price === bid[0])
              if (i > -1) {
                if (bid[1] === 0) {
                  obook.Bid.splice(i, 1)
                } else {
                  obook.Bid[i].Qty = bid[1]
                }
              } else {
                obook.Bid.push({
                  Price: bid[0],
                  Qty: bid[1]
                })
                // console.log('obook bid added', bid[0], bid[1])
              }
              obook.Bid.sort((a, b) => {
                if (a.Price < b.Price) {
                  return 1
                } else {
                  return -1
                }
              })
              // console.log('obook bid sorted', obook.Ask)
              obook.Bid = obook.Bid.slice(0, OBOOK_INT_SIZE)
              // this.orderbook.Bid = obook.Bid.slice(0, OBOOK_DISPLAY_DEPTH)
            }
          })
        }
      }
    },
    updateOrderBook () {
      if (this.$store.state.sys.tradeExchange.ExchId === undefined) {
        return
      }
      if (
        this.$store.state.sys.tradeExchange.ExchId === 'FTX' ||
        this.$store.state.sys.tradeExchange.ExchId === 'OKX' ||
        this.$store.state.sys.tradeExchange.ExchId === 'BIN' ||
        this.$store.state.sys.tradeExchange.ExchId === 'BIF' ||
        this.$store.state.sys.tradeExchange.ExchId === 'BYB' ||
        this.$store.state.sys.tradeExchange.ExchId === 'BYF' ||
        this.$store.state.sys.tradeExchange.ExchId === 'GET' ||
        this.$store.state.sys.tradeExchange.ExchId === 'GEF'
      ) {
        // this.ftxWs()
        return
      }
      Api.get(
        'exch/orderbook?token=' +
          this.$store.state.sys.token +
          '&eid=' +
          this.$store.state.sys.tradeExchange.ExchId +
          '&symbol=' +
          this.$store.state.trade.symbol
      )
        .then(response => {
          // console.log(response.data)
          if (response.data.orderbook) {
            this.orderbook = response.data.orderbook
            this.priceusd = parseFloat(response.data.priceusd)
            this.$store.state.sys.lastPrice = response.data.lastprice
            if (this.$store.state.trade.type === 'market') {
              if (this.$store.state.trade.side === 'B') {
                this.$store.state.trade.price = this.orderbook.Ask[this.orderbook.Ask.length - 1].Price
              } else {
                this.$store.state.trade.price = this.orderbook.Bid[0].Price
              }
            }

            // dec places
            if (
              this.$store.state.trade.pair[1] === 'BTC' ||
              this.$store.state.trade.pair[1] === 'ETH'
            ) {
              this.decPlaces = 4
            } else {
              this.decPlaces = 2
            }
          } else {
            this.orderbook = {}
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    selectPrice (price) {
      // alert(price)
      // this.$store.state.selectedPrice = parseFloat(price)
      // Decimal.set({ toExpNeg: -10 })
      this.$store.state.trade.price = new Decimal(price).toDP(8).toString()
    }
  },
  created () {
    // console.log(config.dev.baseUrl)
    this.updateOrderBook()
    this.orderbookInterval = setInterval(this.updateOrderBook, 3000)
    this.orderbookFtxInterval = setInterval(this.updateFtxWsSnapshot, 5000)

    this.closeOkxStream()
    this.closeBybitStream()
    this.closeBinStream()
    this.closeBitgetStream()
    this.startOKXStream()
    this.startBybitStream()
    this.startBINStream()
    this.startBitgetStream()
  },
  destroyed () {
    this.closeOkxStream()
    this.closeBybitStream()
    this.closeBinStream()
    this.closeBitgetStream()
    clearInterval(this.orderbookInterval)
    clearInterval(this.orderbookFtxInterval)
  }
}
</script>
